'use client'
import * as React from 'react'

// Plain-<img> resilient wrapper. Use when next/image is overkill
// (decorative tiles, mosaic mocks) but you still want a graceful
// fallback when an Unsplash photo 404s or a CDN URL goes dark.
// Cycles through up to two fallbacks before giving up.

const FALLBACKS = [
  'https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=900&h=900&q=80',
  'https://images.unsplash.com/photo-1542060748-10c28b62716f?auto=format&fit=crop&w=900&h=900&q=80',
]

type Props = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  src: string
  fallbacks?: string[]
}

export function ResilientImg({ src, fallbacks = FALLBACKS, alt = '', ...rest }: Props) {
  const [stage, setStage] = React.useState(0)
  const current = stage === 0 ? src : fallbacks[Math.min(stage - 1, fallbacks.length - 1)]
  return (
    <img
      {...rest}
      src={current}
      alt={alt}
      onError={() => setStage((s) => (s < fallbacks.length ? s + 1 : s))}
    />
  )
}
